import http from '@yld/yun-utils-http'
import config from '@yld/yun-utils-host'

const api10020 = '/api/10020'
const api10067 = '/api/10067'
const api40002 = '/api/40002'

// 企业微信登录操作
// 获取生成二维码token
export function get_qr_code() {
  return http.post(config.BASE_URL.WG + api10020 + '/bp/wechat/get_qr_code')
}
// 轮询获取扫码状态
export function get_scan_status(data) {
  return http.post(config.BASE_URL.WG + api10020 + '/bp/wechat/get_scan_status', data)
}
// 更新扫码状态
export function update_scan_status(data) {
  const opts = {}
  opts.header = {
    'xReferrerOpenId': sessionStorage.getItem('xReferrerOpenId')
  }
  return http.post(config.BASE_URL.WG + api10020 + '/bp/wechat/update_scan_status', data, opts)
}
// 企业微信回调
export function wechat_callback(data) {
  const opts = {}
  opts.header = {
    'xReferrerOpenId': sessionStorage.getItem('xReferrerOpenId')
  }
  return http.post(config.BASE_URL.WG + api10020 + '/bp/wechat/wechat_callback', data, opts)
}
// 获取企业微信秘钥
export function wechat_auth_jsapi(data) {
  return http.post(config.BASE_URL.WG + api10020 + '/bp/wechat/auth_jsapi', data)
}

// 账号密码操作
export function login(data) {
  const opts = {}
  opts.header = {
    'xReferrerOpenId': sessionStorage.getItem('xReferrerOpenId')
  }
  return http.post(config.BASE_URL.WG + api10020 + '/sso/login', data, opts)
}

// 手机验证码登录
export function smsLogin(data) {
  const opts = {}
  opts.header = {
    'xReferrerOpenId': sessionStorage.getItem('xReferrerOpenId')
  }
  return http.post(config.BASE_URL.WG + api10020 + '/sso/phoneLogin', data, opts)
}

// 邮箱验证码登录
export function emailLogin(data) {
  const opts = {}
  opts.header = {
    'xReferrerOpenId': sessionStorage.getItem('xReferrerOpenId')
  }
  return http.post(config.BASE_URL.WG + api10020 + '/sso/email_login', data, opts)
}

// 验证滑块并获取手机验证码
export function getPhoneCode(data) {
  return http.post(config.BASE_URL.WG + api10020 + '/sso/checkCode', data)
}

// 验证滑块并获取邮箱验证码
export function getEmailCode(data) {
  return http.post(config.BASE_URL.WG + api10020 + '/sso/email_check_code', data)
}

// 查询租户授权应用
export function getApps(data) {
  return http.post(config.BASE_URL.WG + api10067 + '/tenant/permission/getApps', data)
}
// 手机号注册
export function userRegister(data) {
  const opts = {}
  opts.header = {
    'xReferrerOpenId': sessionStorage.getItem('xReferrerOpenId')
  }
  return http.post(config.BASE_URL.WG + api40002 + '/web/user/register', data, opts)
}
// 判断用户是否设置密码
export function whetherPasswordLogin(data) {
  return http.post(config.BASE_URL.WG + api10020 + '/sso/phoneLogin', data)
}
// 自动创建账号设置密码
export function createUserPassword(data) {
  const opts = {}
  opts.header = {
    'xReferrerOpenId': sessionStorage.getItem('xReferrerOpenId')
  }
  return http.post(config.BASE_URL.WG + api40002 + '/web/user/createPwd', data, opts)
}

/**
 * 获取公众号二维码和token
 * @param {*} data
 * @returns
 */
export function getQrCodeAndToken(data) {
  return http.post(config.BASE_URL.WG + api10020 + '/scan/login/get_qr_code_and_token', data)
}

/**
 * 获取个人微信扫码状态
 * @param {*} data
 */
export function getWechatScanStatus(data) {
  return http.post(config.BASE_URL.WG + api10020 + '/scan/login/get_scan_status', data)
}

/**
 * 退出
 * @returns
 */
export function logout() {
  return http.post(config.BASE_URL.WG + api10020 + '/sso/logout')
}
